import {styled} from '../../styled-components';

export interface DialogStyleProps {
    /**
     * When `true`, dialog will stretch to `maxWidth`
     */
    fullWidth?: boolean;
}

export const DialogStyle = styled.div<DialogStyleProps>`
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    overflow-y: auto;
    max-width: 80vw;
    max-height: ${props => `calc(100% - ${props.theme.spacing.units(4)})`};
    margin: ${props => props.theme.spacing.units(4)} auto;
    pointer-events: auto;
    font-family: ${props => props.theme.typography.fontFamily};
    width: ${props => (props.fullWidth ? '100%' : props.theme.spacing.units(60))};
`;

DialogStyle.displayName = 'DialogStyle';
